import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  paymentPage:{
    //
  }
});

export default styles;